"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HDKeyConfig = exports.Versions = void 0;
/**
 * Versions to serialize private/public keys.
 * (mainnet: 0x0488B21E public, 0x0488ADE4 private; testnet: 0x043587CF public, 0x04358394 private)
 */
class Versions {
}
exports.Versions = Versions;
/**
 * The options to initialize a new HD wallet
 */
class HDKeyConfig {
    /**
     * Ctor
     * @param type the encryptionn mode
     * @param versions the versions to serialize private/public key
     * @param masterSecret the master secret to use for the master-seed for HMAC0-SHA512 process
     */
    constructor(type, versions, masterSecret) {
        this.encryptionType = type;
        this.versions = versions;
        this.masterSecret = masterSecret;
    }
}
exports.HDKeyConfig = HDKeyConfig;
